import { render, staticRenderFns } from "./RequisitionDetailFormDialog.vue?vue&type=template&id=920b3e86&"
import script from "./RequisitionDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports